import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const customerRoutes: RouteObject[] = [
  {
    path: '/search',
    element: lazyElement(() => import('./Search')),
    handle: {
      documentTitle: 'Search Customers',
      crumb: () => ({ label: 'Search Customers', to: '/search' })
    },
  },
];

export default customerRoutes;
